module.exports = __webpack_public_path__ + "static/media/ciel-paris2.b74a9522.png";